module.exports = __webpack_public_path__ + "static/media/coverimage.2be75977.png";